import ContentContainer from '@components/ContentContainer';

const EmbedPage = () => {
  return <ContentContainer.NotFound />;
};

export default EmbedPage;
